<template>
  <div class="search-results-work">
    <div class="results">
      <div v-for="(result, index) in getSearchResults" :key="index">
        <div class="work-item">
          <Accordion>
            <template slot="header">
              <div class="header">
                <RouterLink v-if="$production.toUpperCase() === 'LISTEN'"
                            :to="{ name: 'workById', params: { locale: $i18n.localePath(), workId: result.id }}"
                            class="name" @click.native="linkOnClick(result, 'workById')" v-html="displayName(result)"
                >
                  <!--  -->
                </RouterLink>
                <a v-else :href="workResultURL(result)" target="_blank" rel="noopener noreferrer" class="name" @click="linkOnClick(result, 'workById')" v-html="displayName(result)" />
              </div>
            </template>
            <template slot="content">
              <div class="content">
                <div v-for="(list, listIndex) in result.movementData" :key="listIndex" class="work">
                  <div class="performer-list">
                    <div class="performer">
                      <template v-if="$production.toUpperCase() === 'LISTEN'">
                        <RouterLink
                          v-for="(performer, pIndex) in list[0].people" :key="pIndex"
                          :to="{ name: 'performerById', params: { locale: $i18n.localePath(), id: performer.id }}"
                          class="performer-name" @click.native="linkOnClick(performer, 'performerById')"
                          v-html="displayPerformerName(performer) + ((pIndex < list[0].people.length - 1) ? ' / ': '')"
                        />
                      </template>
                      <template v-else>
                        <a
                          v-for="(performer, pIndex) in list[0].people" :key="pIndex"
                          :href="performerResultURL(performer)" target="_blank" rel="noopener noreferrer" class="performer-name" @click="linkOnClick(performer, 'performerById')"
                        >
                          {{ displayPerformerName(performer) }}
                        </a>
                      </template>
                    </div>
                  </div>
                  <div class="info">
                    <div class="btn-block">
                      <template v-if="$production.toUpperCase() === 'LISTEN'">
                        <a class="btn" @click="playTrackList(list)">
                          <PlayerStaticPlayBtn :width="32" :height="32" />
                        </a>
                      </template>
                    </div>
                    <div class="movement-list">
                      <div v-for="track in list" :key="track.id" class="movement">
                        <template v-if="$production.toUpperCase() === 'LISTEN'">
                          <RouterLink
                            :to="{ name: 'trackById', params: { locale: $i18n.localePath(), id: track.id }}"
                            class="name" @click.native="linkOnClick(track, 'trackById')"
                            v-html="displayMovementName(track)"
                          />
                        </template>
                        <template v-else>
                          <a
                            :href="trackResultURL(track)"
                            target="_blank" rel="noopener noreferrer" class="name"
                            @click="linkOnClick(track, 'trackById')"
                            v-html="displayMovementName(track)"
                          />
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Accordion>
        </div>
        <div v-if="(index + 1) % 10 === 0 || (index + 1) === getSearchResults.length" class="pgnnp-item">
          <Paganiniplus />
        </div>
      </div>
    </div>
    <SearchNoResultsText :results="getSearchResults" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Paganiniplus from '@/components/tsp/Paganiniplus'

import PlayerStaticPlayBtn from '@/components/player/PlayerStaticPlayBtn'
import Accordion from '@/components/common/Accordion'
import SearchNoResultsText from '@/components/search/SearchNoResultsText'
import LoggerService from '@/assets/services/LoggerService'
import TrackService from '@/assets/services/TrackService'

import { displayTrackName, displayPerformerName } from '@/assets/helpers/TrackHelper'
import { displayMovementName } from '@/assets/helpers/MovementHelper'
import { getCookie } from '@/assets/helpers/UtilHelper'

export default {
  name: 'SearchResultsWork',
  components: {
    Paganiniplus,
    Accordion,
    SearchNoResultsText,
    PlayerStaticPlayBtn
  },
  directives: {},
  props: {
    resultType: {
      type: String,
      default: 'work'
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      pgnnpAudioMode: state => state.player.pgnnpAudioMode,
      isAnyPgnnpAudio: state => state.player.isAnyPgnnpAudio,
      currentTime: state => state.player.currentTime,
      paused: state => state.player.paused
    }),
    getSearchResults() {
      const matchedSearchObj = this.$store.getters.getSearchResults.find(searchObj => searchObj[this.resultType])
      if (matchedSearchObj && matchedSearchObj[this.resultType]) {
        matchedSearchObj[this.resultType].forEach(workItem => {
          let movementData = {}
          let tmp = {}
          workItem.movement.forEach((item, index) => {
            if (item.tracks.length) {
              item.tracks.forEach(track => {
                let peopleArray = []
                let peopleId = ''
                track.people.forEach(person => {
                  peopleArray.push(person.id)
                })
                // Resort people id and organise
                peopleArray.sort()
                peopleArray.forEach(pid => {
                  peopleId += pid + '_'
                })
                // Restructuring movement data
                if (peopleId) {
                  let objectKey = peopleId.slice(0, -1)
                  if (tmp[objectKey] === undefined) {
                    tmp[objectKey] = []
                  }
                  // Filter duplicate isrc
                  let len = Object.keys(tmp[objectKey]).length ? Object.keys(tmp[objectKey]).length : 0
                  if (track.isrc !== null) {
                    let thisIsrc = track.isrc
                    let isDuplicate = tmp[objectKey].some(item => {
                      return (thisIsrc === item.isrc)
                    })
                    if (!isDuplicate) {
                      tmp[objectKey][len] = track
                      tmp[objectKey][len].langs = item.langs
                      // tmp[objectKey][len].i18lang = item.i18lang
                    } else if (track.isrc === undefined) {
                      tmp[objectKey][len] = track
                      tmp[objectKey][len].langs = item.langs
                    }
                  } else {
                    tmp[objectKey][len] = track
                    tmp[objectKey][len].langs = item.langs
                    // tmp[objectKey][len].i18lang = item.i18lang
                  }
                }
              })
              movementData = tmp
            }
          })
          workItem.movementData = movementData
        })
      }
      return (matchedSearchObj && matchedSearchObj[this.resultType]) ? matchedSearchObj[this.resultType] : []
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    displayTrackName,
    displayPerformerName,
    displayMovementName,
    getCookie,
    displayName(result) {
      return result.composer.name + ' - ' + result.name
    },
    workResultURL(result) {
      return (this.$production.toUpperCase() === 'LISTEN')
        ? `/${this.$i18n.localePath()}/composer/${result.composer.id}/${result.id}`
        : `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/composer/${result.composer.id}/${result.id}`
    },
    performerResultURL(result) {
      return (this.$production.toUpperCase() === 'LISTEN')
        ? `/${this.$i18n.localePath()}/performers/${result.id}`
        : `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/performers/${result.id}`
    },
    trackResultURL(result) {
      return (this.$production.toUpperCase() === 'LISTEN')
        ? `/${this.$i18n.localePath()}/tracks/${result.id}`
        : `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/tracks/${result.id}`
    },
    linkOnClick(result, name) {
      if (name === 'workById') {
        const url = `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/composer/${result.composer.id}/${result.id}`
        this.logRecord(result, 'works', url)
      } else if (name === 'trackById') {
        const url = `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/tracks/${result.id}`
        this.logRecord(result, 'tracks', url)
      } else if (name === 'performerById') {
        const url = `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/performers/${result.id}`
        this.logRecord(result, 'performers', url)
      }
    },
    logRecord(result, type, url) {
      const params = {
        userId: this.$store.getters.getProfile.id || '',
        peopleCookieId: window.localStorage.getItem('fingerprint') || '',
        refer: document.referrer || this.$route.query.refer || '',
        keyword: this.$store.getters.getSearchedKeyword || '',
        clickUrl: url || '',
        agent: window.navigator.userAgent,
        trackId: (type === 'tracks') ? result.id : '',
        playlistId: ''
      }
      LoggerService.logUserSearchAction(params)
      // gtag event
      const searchItemData = `[${type.toLowerCase()}] ${result.name} ${result.id}`
      this.$store.dispatch('GTAG_EVENT', {
        action: 'view_search_results',
        data: { 'search_term': searchItemData }
      })
    },
    async playTrackList(trackList) {
      const isFirstPlay = this.getCookie('player_play_count') === null
      if (isFirstPlay) {
        this.$store.commit('SET_TO_PREPEND', true)
        this.$store.dispatch('PGNNP_AUDIO_NEXT')
        this.$nextTick(() => {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
        })
        if (!this.isAnyPgnnpAudio) {
          document.querySelector('#audioPlayer').play()
          document.querySelector('#audioPlayer').pause()
        }
      } else if (!this.paused || this.currentTime > 0) {
        await this.$store.dispatch('INCREASE_PLAYING_COUNT')
        this.$nextTick(() => {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
        })
      }

      if (!this.initialClick) {
        // Trigger click-to-play policy
        document.querySelector('#audioPlayer').play()
        document.querySelector('#audioPlayer').pause()
      }
      let trackIdArray = []
      trackList.forEach(track => {
        trackIdArray.push(track.id)
      })
      let res = await TrackService.getTracks({ id: trackIdArray })
      let sortedAry = trackList.map(track => {
        return res.data.find(item => item.id === track.id)
      }).filter(track => track) // filter undefinded obj
      this.$store.commit('TOGGLE_PLAYER_RANDOM', false)
      this.$store.commit('RESET_QUEUE')
      this.$store.commit('SET_PLAYLIST_TO_QUEUE', sortedAry)
      this.$store.commit('SET_PLAYER_INDEX', 0)
      this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.results {
  .work-item {
    position: relative;
    font-size: 24px;
    overflow: hidden;
    .header {
      width: calc(100% - 24px);
      .name {
        font-size: 16px;
        font-weight: 700;
        line-height: 1.63;
        text-decoration: none;
        color: $grey-9b;
      }
    }
  }
  .pgnnp-item {
    margin: 36px 0;
  }
}
.work {
  padding: 16px 36px 16px 36px;
  border-bottom: solid 1px $grey-ec;
}
.performer {
  &-list {
    margin-left: 52px;
    margin-bottom: 20px;
  }
  display: inline-block;
  color: $grey-7d;
  &-name {
    font-size: 12px;
    font-weight: 500;
    color: $grey-7d;
    text-decoration: none;
    cursor: pointer;
    @media(hover:hover) {
      &:hover {
        color: $link-hover;
      }
    }
  }
}
.info {
  position: relative;
  overflow: hidden;
  .btn-block {
    float: left;
    position: relative;
    overflow: hidden;
    vertical-align: top;
    width: 36px;
    margin: 0 16px 16px 0;
  }
  .movement-list {
    position: relative;
    overflow: hidden;
    .movement {
      width: 100%;
      .name {
        font-size: 16px;
        line-height: 1.63;
        font-weight: 700;
        color: $grey-7d;
        text-decoration: none;
        cursor: pointer;
        @media(hover:hover) {
          &:hover {
            color: $link-hover;
          }
        }
      }
    }
  }
}
.accordion {
  .accordion-header {
    @media (hover:hover) {
      &:hover {
        .name {
          color: $link-hover!important;
        }
      }
    }
  }
  &.active {
    /deep/ .accordion-content {
      max-height: 9999px;
    }
  }
}

@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
@media only screen and (max-width: 368.98px) {
  .results {
    .pgnnp-item {
      margin: 36px -24px;
    }
  }
}
</style>
